import { Component } from '@angular/core';

import { ComponentBase } from '@definitiv-packages/angular-dba-library';

import { AppService, ProjectLanguage, ProjektModuleService, ProjektPermissionService } from '../../../../../roofsafetymanagement-library/src/public-api';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  standalone: false
})
export class SidenavComponent extends ComponentBase<ProjectLanguage> {
  public opened: boolean = false;

  constructor(
    public moduleService: ProjektModuleService,
    public permissionService: ProjektPermissionService,
    public appService: AppService
  ) { super(); }

  public toggle(): void {
    this.opened = !this.opened;
  }
}
